import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { JudgePool, JudgePoolTable } from "../../application/application.service";

@Component({
    selector: 'dialog-judgedivide-component',
    styleUrls: ['judgedivide.dialogcomponent.scss'],
    templateUrl: 'judgedivide.dialogcomponent.html',
})

export class JudgeDivideDialogComponent implements OnInit {
    JudgeCount: number;
    NomCount: number;
    PoolChoices: JudgePool[] = [];
    Selected: JudgePool;
    NomFactors: number[] = [];
    PerfectFactors: number[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<JudgeDivideDialogComponent>
    ) { }

    sliderValue(event) {
        this.Selected = this.PoolChoices[event.value - 1];
    }

    ngOnInit() {
        this.JudgeCount = this.data.JudgeCount;
        this.NomCount = this.data.NomineeCount;
        //s = size of pool
        //p = number of pools

        for (let s = 1; s <= this.NomCount; s++) {
            let p = Math.round(this.NomCount / s);
            let m = Math.floor(this.JudgeCount / p);
            let table: JudgePoolTable[] = [];
            let judgesGrouped = 0;
            let nomGrouped = 0;
            let invalid = false;

            for (let i = 1; i <= p; i++) {
                let grp: JudgePoolTable = new JudgePoolTable();
                //if last group
                if (i === p) {
                    //remaining judges/nominees
                    grp.JudgePerGroup = this.JudgeCount - judgesGrouped;
                    grp.NomPerGroup = this.NomCount - nomGrouped;
                }
                //regular
                else {
                    //add minimum amount of judges
                    grp.JudgePerGroup = m;
                    judgesGrouped = judgesGrouped + m;

                    //add min amount of nominees
                    grp.NomPerGroup = s;
                    nomGrouped = nomGrouped + s;
                }

                table.push(grp);
            }

            //can't have more groups than judges
            if (p > this.JudgeCount) {
                invalid = true;
            }
            //don't want only 1 judge to rate a nominee, must be 2 or more
            if (this.JudgeCount / p < 2) {
                invalid = true;
            }

            if (invalid === false) {
                if (this.NomCount % s === 0) {
                    this.NomFactors.push(s);
                    if (this.JudgeCount % p === 0) {
                        this.PerfectFactors.push(s);
                    }
                }
            }

            let pool: JudgePool = {
                PoolSize: s,
                PoolCount: p,
                MinJudges: m,
                Table: table,
                Invalid: invalid
            };

            this.PoolChoices.push(pool);
        }

        this.Selected = this.PoolChoices[this.PoolChoices.length - 1];
    }

    OkHandler() {
        this.dialogRef.close(this.Selected.Table);
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

    ResetHandler() {
        this.dialogRef.close('reset');
    }
}